const routerArr = [
    {
        path: '/activity',
        name: 'activity',
        meta: { title:'学习中心列表' ,login:true},
        component: () => import(/* webpackChunkName: 'activity' */ './page/index.vue'),
    },
    {
        path: '/activity/detail',
        name: 'activityDetail',
        meta: { title:'学习中心详情' ,login:true},
        component: () => import(/* webpackChunkName: 'activityDetail' */ './page/activityDetail.vue'),
    },
    {
        path: '/activity/evaluatePage',
        name: 'evaluatePage',
        meta: { title:'' ,login:true},
        component: () => import(/* webpackChunkName: 'evaluatePage' */ './page/evaluatePage.vue'),
    }

  ]
  
  export default routerArr